'use client';

import type { FC } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useTranslations } from 'next-intl';
import { AsideTopEntitiesList } from '@/components/shared';
import { TopGamesAliasLabels } from '@/consts/seo/SlotsAliases';
import { AppRoutes } from '@/i18n/constants';
import { isStaging } from '@/libs/getEnvironment';
import { TOP_GAMES_LIMIT, topGamesQueryOptions } from '@/queries/publicSidebars.queries';

interface TopGamesProps {
  className?: string;
}

const SEO_TOP_GAMES = Object.entries(TopGamesAliasLabels)
  .slice(0, TOP_GAMES_LIMIT)
  .map(([alias, name]) => ({
    name,
    href: AppRoutes.slotsSlug(alias),
  }));

export const TopGames: FC<TopGamesProps> = ({ className }) => {
  const t = useTranslations('game');
  const isStagingEnvironment = isStaging();

  const { data: games } = useQuery(topGamesQueryOptions());

  const topGamesFromCategory = games?.items?.map(game => ({
    name: game.name,
    href: AppRoutes.gamesId(game.id),
  }));

  const topGames = isStagingEnvironment
    ? (topGamesFromCategory?.length ? topGamesFromCategory : [])
    : SEO_TOP_GAMES;

  if (!topGames.length) {
    return null;
  }

  // TODO: Use the top games query again when all top games have filled SEO content.
  return <AsideTopEntitiesList className={className} title={t('top-games')} list={topGames} />;
};
